import { ChangeDetectionStrategy, Component, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { AuthState } from 'src/app/states/auth.state';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-dynamic-loader',
  templateUrl: './dynamic-loader.component.html',
  styleUrls: ['./dynamic-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
/**   dynamically load components from lazy loaded modules, if necessary.
 * loads chat component from communication module for staff
 */
export class DynamicLoaderComponent {
  me: any;

  @ViewChild('chatContainer', { read: ViewContainerRef }) chatContainer: ViewContainerRef;
  chatComponentLoaded: boolean;
  
  constructor(private sharedService: SharedService) {
    AuthState.user$.subscribe(async user => {
      if(!user) return;
      this.me = sharedService.me;
      await this.loadDynamicModules();
    });
  }
  async loadDynamicModules() {
    //check if current user has chat enabled
    if(this.me.IsStaff)
      await this.loadChatComponent();
  }
  async loadChatComponent() {
    if(this.chatComponentLoaded) return;
    this.chatComponentLoaded = true;
    const { ChatLoaderComponent } = await import('src/app/modules/communication/components/chat-loader/chat-loader.component');
    const chatComponent = this.chatContainer.createComponent(ChatLoaderComponent);
    chatComponent.changeDetectorRef.detectChanges(); //TODO: check if this line is needed after fixing change detection on chat component
  }


}
